/**
 * The pre-call SMS is in limited rollout while we validate the message wording and the
 * outbound SMS volume, so the button is restricted to the CS and engineering folks
 * trialling it rather than every employee. This applies in every environment.
 *
 * This gate hides the UI; it is not a security boundary. The underlying notification-proxy
 * endpoint authorises on the admin roles, so anyone with those roles can still call the API
 * directly. Narrow the endpoint too if that matters.
 */
export const PRE_CALL_SMS_ALLOWED_EMAILS: ReadonlyArray<string> = [
  'koren.sela@luxuryescapes.com',
  'lachlan.mellington@luxuryescapes.com',
  'jamie.lane@luxuryescapes.com',
  'min.pangastur@luxuryescapes.com',
  'hardik.purohit@luxuryescapes.com',
];

const allowedEmails = new Set(PRE_CALL_SMS_ALLOWED_EMAILS.map((email) => email.toLowerCase()));

export function canSendPreCallSms(user: { email?: string | null } | null | undefined): boolean {
  if (!user?.email) {
    return false;
  }

  return allowedEmails.has(user.email.trim().toLowerCase());
}
